
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../../main/components/nav-left/nav-left.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import {
  GetCards,
  DelCard,
  SaveCard,
  ExportCard,
  OpenCard,
  ReadCode,
} from "@/request/setting";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Name extends mixins(listMixin) {
  // private H: any = "";
  private zhuangtais: any = ["未激活", "已激活"];
  private zhuangtais2: any = ["未开卡", "已开卡"];
  private cardType: any = ["宜心卡", "宜心相随-爱心卡", "宜心相随-尊享爱心卡"];
  private data: any = [];
  private ifShowEdit: any = false;
  private ifShowKaika: any = false;
  private cardTime: any = "";
  private card_id: any = "";
  private editMsg: any = {};
  private codeImg: any = "";
  private ifShowCode: any = false;
  private get configuration() {
    return this.$store.state.configuration;
  }
  private readCode() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ReadCode(this, loading)
      .then((res: any) => {
        loading.close();
        this.codeImg = res.url;
        this.ifShowCode = true;
      })
      .catch(() => {
        loading.close();
      });
  }
  private cancelKai(item: any) {
    this.$confirm("您确定要取消开卡吗？")
      .then(() => {
        const params: any = {
          card_id: item.card_id,
          操作: "取消开卡",
        };
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        OpenCard(this, params).then((res: any) => {
          loading.close();
          this.$message.success("取消开卡成功");
          this.getList();
        });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private openKaika(item: any) {
    const now: any = new Date();
    const year: any = now.getFullYear(); // 得到年份
    let month: any = now.getMonth(); // 得到月份
    let date: any = now.getDate(); // 得到日期
    let hour: any = now.getHours(); // 得到小时
    let minu: any = now.getMinutes(); // 得到分钟
    month = month + 1;
    if (month < 10) {
      month = "0" + month;
    }
    if (date < 10) {
      date = "0" + date;
    }
    if (hour < 10) {
      hour = "0" + hour;
    }
    if (minu < 10) {
      minu = "0" + minu;
    }
    let time = "";
    time = year + "-" + month + "-" + date + " " + hour + ":" + minu;
    this.cardTime = time;
    this.ifShowKaika = true;
    this.card_id = item.card_id;
  }
  private kaika() {
    const params: any = {
      card_id: this.card_id,
      操作: "开卡",
      开卡时间: this.cardTime,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    OpenCard(this, params).then((res: any) => {
      loading.close();
      this.$message.success("开卡成功");
      this.ifShowKaika = false;
      this.getList();
    });
  }
  private add() {
    this.editMsg = {};
    this.ifShowEdit = true;
  }
  private exportData() {
    const params: any = {
      类型: this.filters["类型"],
      状态: this.filters["状态"],
      sort_value: this.filters.sort_value,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ExportCard(this, params, loading).then((res: any) => {
      loading.close();
      window.open(res);
    });
  }
  private save() {
    if (!this.editMsg["健康卡类型"]) {
      this.$message.warning("健康卡类型必须选择");
      return;
    }
    if (!this.editMsg["数量"]) {
      this.$message.warning("数量必须填写");
      return;
    }
    const reg: any = /^[0-9]*[1-9][0-9]*$/;
    if (!reg.test(this.editMsg["数量"])) {
      this.$message.warning("数量只能输入正整数");
      return;
    }
    const params: any = {
      类型: this.editMsg["健康卡类型"],
      数量: this.editMsg["数量"],
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    SaveCard(this, params).then((res: any) => {
      loading.close();
      this.$message.success("批量创建成功！");
      this.ifShowEdit = false;
      this.search();
    });
  }
  private delOne(item: any) {
    this.$confirm("您确定需要删除么，删除后不可恢复！")
      .then(() => {
        const params: any = {
          card_id: item.card_id,
        };
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        DelCard(this, params)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功!");
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  getList() {
    console.log(this.filters);
    const params: any = {
      类型: this.filters["类型"],
      激活状态: this.filters["激活状态"],
      开卡状态: this.filters["开卡状态"],
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
      sort_value: this.filters.sort_value,
      卡号: this.filters.search,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("sourceFilter", JSON.stringify(this.filters));
    GetCards(this, params)
      .then((data: any) => {
        loading.close();
        this.data = data.datas;
        this.filters.total_count = data.total_count;
        this.filters.total_page = data.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_value = 1;
    if (localStorage.getItem("sourceFilter")) {
      this.filter = JSON.parse(localStorage.getItem("sourceFilter") as any);
    }
    this.getList();
    // this.H = document.body.clientHeight - 114;
  }
}
